
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play/characters/[characterId]",
      function () {
        return require("private-next-pages/play/characters/[characterId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/play/characters/[characterId]"])
      });
    }
  